import React from 'react';
import { BaseEdge, getStraightPath } from '@xyflow/react';
import { connStyle } from '@/lib/connections';

// Straight center-to-center connection used on location plans (a map/floorplan
// overlay reads more naturally with direct lines than orthogonal routing).
export function LocationEdge({ id, sourceX, sourceY, targetX, targetY, data, selected }) {
  const [path] = getStraightPath({ sourceX, sourceY, targetX, targetY });
  const style = connStyle(data?.connType, selected);
  return <BaseEdge id={id} path={path} style={style} />;
}
